import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
// services
import { ExcessPaymentService } from '../../services/excess-payment.service';
import { ErrorHandler } from '../../services/error-handler.service';

interface CustomsPaymentRequest {
  bookingReference: string;
  bookingJourneyReference: string;
  pspReference: string;
  businessTransactionType: string;
}

@Component({
  selector: 'app-booking-details-customs-payment',
  templateUrl: './booking-details-customs-payment.component.html',
  styleUrls: ['./booking-details-customs-payment.component.scss']
})
export class BookingDetailsCustomsPaymentComponent implements OnInit {
  @Input()
  appCopy;
    
  @Input()
  selectedLanguage;
  
  @Input()
  bookingRef;

  @Input()
  user;

  @Input()
  adminBookingDetails;

  @Output()
  redirectToBooking: EventEmitter<any> = new EventEmitter();

  private excessPaymentSubscription: Subscription;

  public excessCustomsPayment;
  public receiptImg;
  public isLoading = false;
  public currencySymbol = '';

  constructor(
    private _excessPaymentService: ExcessPaymentService,
    private _errorHandler: ErrorHandler,
    private _router: Router
  ) { }

  ngOnInit() {

    this.excessCustomsPayment = this.adminBookingDetails.bookingJourneyDetails[0].excessBaggagePayment;
    this.currencySymbol = this.adminBookingDetails.bookingJourneyDetails[0].paymentDetails.currencySymbol;
    if (this.excessCustomsPayment !== null) {
      this.receiptImg = this.excessCustomsPayment.receiptImageURL;
    }

    this.excessPaymentSubscription = this._excessPaymentService.excessPaymentSubject$
      .subscribe(res => {

        if (res === 'error') {
          this.isLoading = false;
          return;
        }

        this._errorHandler.handleCustomMessage({
          text: 'Customs payment settled. You\'ll be redirected back to booking details',
          type: 'success'
        });

        setTimeout(() => {
          const url = `my-account/bookings/booking-details?ref=${this.bookingRef}`;
          this._router.navigateByUrl(url);
        }, 2500);

      });

  }

  handleExcessPaymentSubmit(value, event) {
    event.preventDefault();

    this.isLoading = true;

    const request: CustomsPaymentRequest = {
      bookingReference: this.adminBookingDetails.bookingJourneyDetails[0].bookingReference,
      bookingJourneyReference: this.adminBookingDetails.bookingJourneyDetails[0].bookingJourneyReference,
      pspReference: value.pspReference,
      businessTransactionType: this.adminBookingDetails.bookingJourneyDetails[0].excessBaggagePayment.businessTransactionType
    };

    this._excessPaymentService.postExcessPayment(request);

  }

  ngOnDestroy() {
    this.excessPaymentSubscription.unsubscribe();
  }

}
